import clsx from 'clsx';

import { Flex, type FlexProps } from '@commons/containers/Flex';

import styles from './index.module.scss';

/**
 * PartialFluidSectionContentRegion component.
 */

const PartialFluidSectionContentRegion = (props: FlexProps) => {
  const { children, className, ref, ...rest } = props;

  const classes = clsx(styles.contentRegion, className);

  return (
    <Flex ref={ref} className={classes} {...rest}>
      {children}
    </Flex>
  );
};

export default PartialFluidSectionContentRegion;
